module.exports = __webpack_public_path__ + "img/palestine.45ed039b.svg";